import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../../';
import PropTypes from 'prop-types';

var Banner = function Banner(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('cloud-ui-banner', "banner-".concat(props.type))
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "error-solid"
  }), /*#__PURE__*/React.createElement("div", {
    className: "banner-text"
  }, props.children), props.onClose && /*#__PURE__*/React.createElement("button", {
    onClick: props.onClose,
    className: "banner-close"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  })));
};

export default Banner;
Banner.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func
};